<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import LocalIcon from '@/atoms/LocalIcon.vue';
import { buildRisks } from '@/parcours/flows/stress/riskStress.config';
import RowItemContainer, { ClickableRowItemProps } from '@/organisms/RowItemContainer.vue';

const router = useRouter();
const route = useRoute();

const props = defineProps<{
  data: any;
}>();

function getRisk(level: number, min: number, max: number) {
  if (level < min) {
    return { label: 'Faible', color: 'text-success-primary' };
  }
  if (level < max) {
    return { label: 'Modéré', color: 'text-warning-primary' };
  }
  return { label: 'Élevé', color: 'text-error-solid' };
}

const risksChart = computed(() => buildRisks(props.data));

async function goToSymptomDetail(riskLabel: string) {
  await router.push({
    name: `flow-${route.meta.flowId}-symptomDetail`,
    params: route.params,
    query: { symptom: riskLabel },
  });
}

const rowItems = computed<ClickableRowItemProps[]>(() =>
  risksChart.value.map((risk) => ({
    id: risk.level,
    descriptionProps: {
      text: `${risk.level}/${risk.total} | ${getRisk(risk.level, risk.min, risk.max).label}`,
      class: getRisk(risk.level, risk.min, risk.max).color,
    },
    class: 'py-4',
    title: risk.label,
    onClick: () => goToSymptomDetail(risk?.label),
  })),
);
</script>

<template>
  <div class="w-full text-primary">
    <RowItemContainer :row-items="rowItems" row-item-type="RowItem">
      <LocalIcon background="brand" class="fill-grey-600" name="info" size="36" />
    </RowItemContainer>
  </div>
</template>
